import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const Group = makeShortcode("Group");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Item title="merchantName" subtitle="String?" mdxType="Item">
    Set it the merchant name that you want to be shown on the Google Pay screen.
    </Item>
    <Item title='allowedCardNetworks' subtitle='List<String>' label='Default: listOf("AMEX", "DISCOVER", "JCB", "MASTERCARD","VISA")' mdxType="Item">
      <p>{`Sets
the `}<a parentName="p" {...{
          "href": "https://developers.google.com/pay/api/android/guides/tutorial#supported-card-networks"
        }}>{`card networks`}</a>{`
that your application accepts.`}</p>
    </Item>
    <Item title="buttonStyle" subtitle="GooglePayButtonStyle" label="Default: GooglePayButtonStyle.BLACK" mdxType="Item">
    Sets the style of the Google Pay button.
    <Group summary="GooglePayButtonStyle" mdxType="Group">
        <Item title="BLACK" mdxType="Item">Style of button to be used on light theme.</Item>
        <Item title="WHITE" mdxType="Item">Style of button to be used on dark theme.</Item>
    </Group>
    </Item>
    <Item title="captureBillingAddress" subtitle="Boolean" label="Default: false" mdxType="Item">
    Sets whether user's billing address should be captured from Google Pay.
    </Item>
    <Item title='existingPaymentMethodRequired' subtitle='Boolean' label='Default: false' mdxType="Item">
      <p>{`If set to `}<inlineCode parentName="p">{`true`}</inlineCode>{`, this specifies that Google Pay can only be used for payments if the user's Google
Pay wallet already contains allowed payment methods.`}</p>
    </Item>
    <Item title='shippingAddressParameters' subtitle="PrimerGoogleShippingAddressParameters" label="Default: null" mdxType="Item">
    Indicates whether the shipping address should be collected during the
    checkout process. Note that setting at least one shipping method in
    Checkout. Shipping module is necessary
    <Group summary="PrimerGoogleShippingAddressParameters" mdxType="Group">
        <Item title="phoneNumberRequired" subtitle="Boolean" label="Default: false" mdxType="Item">
            Sets whether the phone number should also be collected.
        </Item>
    </Group>
    </Item>
    <Item title='requireShippingMethod' subtitle='Boolean' label='Default: false' mdxType="Item">
  Indicates whether selecting a shipping method is required during the checkout process.
  At least one shipping option should be configured in order to use this option.
      <p>{`This should be set to `}<inlineCode parentName="p">{`true`}</inlineCode>{` if the `}<inlineCode parentName="p">{`shippingAddressParameters`}</inlineCode>{` are also used.`}</p>
    </Item>
    <Item title="emailAddressRequired" subtitle="Boolean" label="Default: false" mdxType="Item">
    Indicates whether the email address should be collected during the checkout
    process.
    </Item>
    <Item title="buttonOptions" subtitle="GooglePayButtonOptions" mdxType="Item">
  A configuration class for customizing the appearance of the Google Pay button.
  <Group open mdxType="Group">
        <Item title="buttonType" subtitle="Int" mdxType="Item">
          <p>{`Google Pay Button type as described in the official `}<a parentName="p" {...{
              "href": "https://developers.google.com/pay/api/android/guides/brand-guidelines"
            }}>{`documentation`}</a>{`.`}</p>
        </Item>
  <Item title="buttonTheme" subtitle="Int" mdxType="Item">
          <p>{`Google Pay button style as described in the official `}<a parentName="p" {...{
              "href": "https://developers.google.com/pay/api/android/guides/brand-guidelines#personalization"
            }}>{`documentation`}</a></p>
        </Item>
      </Group>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      